import { SearchTreeNode } from '@/types/searchTreeTypes';

// Quick and dirty, might not be relevant once we have validation working.
// This is used to disable Apply/Save until there is *something* in the tree.
export function searchTreeIsEmpty(node: SearchTreeNode | undefined): boolean {
  if (node === undefined) {
    return true;
  }
  if (node.op === 'filter') {
    // Not bothering right now to check more than something is there, at time of
    // writing the invalid bits are just deleted, not ideal but does the trick
    // for now
    return false;
  }

  return node.nodes.length === 0 || node.nodes.every(searchTreeIsEmpty);
}

